import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';

import { filter } from 'rxjs/operators';



@Injectable()
export class RouteUtilService {
  /*********************Properties*********************/
 
  setNav$: Subject<any> = new Subject<any>();
  private prevUrl:any = null;
  private currUrl:any = null;
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((e: any) => {
        this.prevUrl = this.currUrl;
        this.currUrl = e.url;
      });
  }
  /*********************Constructor*********************/

  /*********************Utility Methods*********************/

  navigate(url: any, data: any = null): void {
  
    this.router.navigateByUrl(url, { state: data, replaceUrl: true });
  }


  redirectToLogin() {
    this.navigate('');
  }

  /*********************Utility Methods*********************/

  /*********************Private Methods*********************/

  

  /*********************Private Methods*********************/
}
